import { Route, Navigate, Outlet, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getRoleOfUser} from "../../api/userApiFunctions"
import { getUserID, isLoggedIn } from "../../Utility/service";
import { CustomSpinner } from "../common/CustomSpinner";
import { getAssistantInfo } from "../../api/assistantApiFunctions";

const ProtectedRoutes = () => {
  const [userRole, setUserRole] = useState(null);
  const [isPublic, setIsPublic] = useState(false);
  const [loading, setLoading] = useState(true);
  const [checkUser, setCheckUser] = useState(false);
  const [organizational, setIsOrganizational] = useState(false);

  const { assistant_id } = useParams();
  const userId = getUserID();

  useEffect(() => {
    const fetchData = async () => {
      if (!isLoggedIn() || !userId) {
        setLoading(false);
        return;
      }
      setLoading(true);

      try {
        
        await getRoleOfUser(userId, setUserRole, setIsPublic);

        if (assistant_id) {
          await getAssistantInfo(userId, assistant_id, setCheckUser, setIsPublic, setIsOrganizational);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, assistant_id]);

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <CustomSpinner />;
  }

  if (checkUser || userRole === "superadmin" || isPublic || organizational) {
    return <Outlet />;
  }

  return <Navigate to="*" replace />;
};

export default ProtectedRoutes;